// packages/hooks/useOrders.ts

import { useData } from "../core/useData";
import { useToken } from "../auth/useToken";
import { useState } from "react";
import { QueryFilters } from "../../types/core/BaseService";
import { orderService } from "../../services/orderService";
import { Order } from "../../types/Order";

export function useOrders(initialFilters?: QueryFilters) {
    const { token } = useToken();
    const [loadingStatus, setLoadingStatus] = useState(false);

    const {
        data: orders,
        loading,
        error,
        refresh,
        deleteItem,
        updateItem,
        deleteManyItems
    } = useData<Order>({
        ...orderService,
        ...orderService.baseService
    }, initialFilters);

   

 
    const updateOrderStatus = async (id: string, status: string) => {
        setLoadingStatus(true);
        if (!token) {
            throw new Error("Veillez vous connecter");
        }
        try {
            const result = await orderService.updateOrderStatus(id, status, token);
            await refresh();
            return result;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setLoadingStatus(false);
        }
    };

    return {
        orders,
        loading: loading || loadingStatus,
        error,
        refresh,
        deleteOrder: deleteItem,
        updateOrder: updateItem,
        updateOrderStatus,
        deleteManyOrders: deleteManyItems,
     
    };
}